<template>
	<div id="qcode1" class="page" v-if="loaded">
		<div class='qcode'>
			<img v-bind:src="user.sell_qcode" style="width:50vw;height:50vw;display:block;margin:5vw auto;"/>
			<div class="content" v-html="this.$store.state.config.data.qcode_business_content"></div>
			<div style="margin:5vw auto;text-align:center;font-size:5.2vw;" v-on:click="calling">客服电话：{{user.mobile}}</div>
		</div>
	</div>
</template>

<script>
import { Toast , Dialog} from 'we-vue'
export default {
	data () {
		return {
			loaded:false,
			user:{},
			config:{}
		}
	},
	created () {
		this.$https.post("/api/distribution/__qcode1",this.$qs.stringify({
			token:this.$store.state.token,
			user_id:this.$route.query.user_id
		})).then((res) => {
			this.user = res.data.data
			this.config = this.$store.state.config.data
			this.loaded = true
		});
	},
	methods: {
		calling(){
			
		}
	},
	filters: {
    
	}
}
</script>

<style scoped>
	#qcode1{
		background-color:#f8c9ed;
		min-height:100vh;
		padding-top:3vw;
	}
	.qcode{
  padding:0px 3vw;
  color:#434343;
}
.qcode .title{
  height:50px;
  text-align:center;
  font-size:16px;
  line-height:50px;
}
.qcode .content{
}
.qcode .content .userinfo{
  padding:5vw;
  line-height:15vw;
  height:15vw;
}
.qcode .content .userinfo img{
  width:15vw;
  height:15vw;
  border-radius:7.5vw;
  vertical-align: middle;
  margin-right:3vw;
}
.qcode .content .qcodeinfo{
  padding:2vw 5vw 5vw 5vw;
}
.qcode .content .qcodeinfo img{
  width:100%;
}
.qcode .button{
  margin-top:10px;
  line-height:50px;
  height:50px;
  text-indent:15px;
  font-size:16px;
  background-color:#FFFFFF;
  box-shadow:0px 0px 10px #CCCCCC;
}
.qcode .button text{
  float:right;
  margin-right:15px;
}
</style>


// WEBPACK FOOTER //
// src/components/Qcode1.vue